import styled from 'styled-components'
import { List, Col } from '@gympass/yoga'
import tokens from '@gympass/yoga-tokens'

import Image from '@components/Image'
import { H1, H6 } from '@components/Text'

export const CompanyInvestmentWrapper = styled.section`
  background-color: ${tokens.colors.clear};
  padding-top: 20px;
  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    padding-top: 0;
  }
`

export const Title = styled(H1)`
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 29px;
  color: #001027;
  margin: 28px 0 0 0;

  @media (min-width: ${tokens.breakpoints.md.width}px) {
    margin: 36px 0 0;
  }

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    margin: 80px 0 0 0;
    font-size: 32px;
    line-height: 42px;
  }
`

export const Subtitle = styled(H6)`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  margin: 16px 0 0 0;
  letter-spacing: 0.5px;

  @media (min-width: ${tokens.breakpoints.md.width}px) {
    margin: 16px 0 0;
  }

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    font-size: 16px;
    line-height: 21px;
    margin: 9px 0 0 0;
  }
`
export const ListWrapper = styled.section`
  margin-top: 48px;

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    display: flex;
    margin-top: 40px;
    justify-content: space-between;
  }
`

export const ListIcon = styled(Image)`
  height: 16px;
  margin-right: 10px;
  margin-top: 5px;
`

export const ListItem = styled(List.Item)`
  display: flex;
  margin-bottom: 16px;
  padding: 0;
  flex-direction: row;

  &:last-of-type {
    margin-bottom: 0;
  }

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    flex-direction: column;
    align-items: center;
    width: 184px;
    margin-bottom: 0px;
  }
`

export const ListItemDescription = styled(H6)`
  font-weight: 400;
  line-height: 24px;
  text-align: center;
`

export const OrderableColumn = styled(Col)`
  @media (min-width: ${tokens.breakpoints.md.width}px) {
    order: 2;
  }
`
export const DividerWrapper = styled.section`
  margin-top: 65px;
`
